import { jsx } from "react/jsx-runtime";
import * as React from "react";
import * as prismicH from "@prismicio/helpers";
import { __PRODUCTION__ } from "./lib/__PRODUCTION__.js";
import { devMsg } from "./lib/devMsg.js";
import { isInternalURL } from "./lib/isInternalURL.js";
import { usePrismicContext } from "./usePrismicContext.js";
const defaultInternalComponent = "a";
const defaultExternalComponent = "a";
const _PrismicLink = (props, ref) => {
  const context = usePrismicContext();
  if (!__PRODUCTION__) {
    if ("field" in props && props.field) {
      if (!props.field.link_type) {
        console.error(`[PrismicLink] This "field" prop value caused an error to be thrown.
`, props.field);
        throw new Error(`[PrismicLink] The provided field is missing required properties to properly render a link. The link will not render. For more details, see ${devMsg("missing-link-properties")}`);
      } else if (Object.keys(props.field).length > 1 && !("url" in props.field || "uid" in props.field || "id" in props.field)) {
        console.warn(`[PrismicLink] The provided field is missing required properties to properly render a link. The link may not render correctly. For more details, see ${devMsg("missing-link-properties")}`, props.field);
      }
    } else if ("document" in props && props.document) {
      if (!("url" in props.document || "id" in props.document)) {
        console.warn(`[PrismicLink] The provided document is missing required properties to properly render a link. The link may not render correctly. For more details, see ${devMsg("missing-link-properties")}`, props.document);
      }
    }
  }
  const linkResolver = props.linkResolver || context.linkResolver;
  let href;
  if ("href" in props) {
    href = props.href;
  } else if ("document" in props && props.document) {
    href = prismicH.asLink(props.document, linkResolver);
  } else if ("field" in props && props.field) {
    href = prismicH.asLink(props.field, linkResolver);
  }
  const isInternal = href && isInternalURL(href);
  const target = props.target || "field" in props && props.field && "target" in props.field && props.field.target || void 0;
  const rel = props.rel || (target === "_blank" ? "noopener noreferrer" : void 0);
  const InternalComponent = props.internalComponent || context.internalLinkComponent || defaultInternalComponent;
  const ExternalComponent = props.externalComponent || context.externalLinkComponent || defaultExternalComponent;
  const Component = isInternal ? InternalComponent : ExternalComponent;
  const passthroughProps = Object.assign({}, props);
  delete passthroughProps.linkResolver;
  delete passthroughProps.internalComponent;
  delete passthroughProps.externalComponent;
  delete passthroughProps.rel;
  delete passthroughProps.target;
  if ("field" in passthroughProps) {
    delete passthroughProps.field;
  } else if ("document" in passthroughProps) {
    delete passthroughProps.document;
  } else if ("href" in passthroughProps) {
    delete passthroughProps.href;
  }
  return href ? /* @__PURE__ */ jsx(
    Component,
    {
      ...passthroughProps,
      ref,
      href,
      target,
      rel
    }
  ) : null;
};
if (!__PRODUCTION__) {
  _PrismicLink.displayName = "PrismicLink";
}
const PrismicLink = React.forwardRef(_PrismicLink);
export {
  PrismicLink
};
//# sourceMappingURL=PrismicLink.js.map
